import { useMondayContext, type MondayContextValue } from '../context/MondayContext';

/**
 * Convenience hook to access the monday.com SDK instance and context.
 *
 * This is a thin wrapper around `useMondayContext` for simpler import paths
 * and a more ergonomic destructuring pattern.
 *
 * Usage:
 * ```ts
 * const { monday, context, isReady, getSessionToken } = useMonday();
 * ```
 */
export function useMonday() {
  const { mondayInstance, context, isReady, getSessionToken }: MondayContextValue =
    useMondayContext();

  return {
    /** The monday SDK instance for executing commands and GraphQL queries */
    monday: mondayInstance,
    /** Current monday.com context (boardId, userId, theme, etc.) */
    context,
    /** Whether the monday.com context has been received */
    isReady,
    /** Async function to get a session token for API auth */
    getSessionToken,
  };
}
